export const AAR_EXPORT_FORMATS = {
  Json: "json",
  Docx: "docx",
} as const;

type FormatType = typeof AAR_EXPORT_FORMATS;
export type AarExportFormat = FormatType[keyof FormatType];
